import React, { FunctionComponent } from 'react';

type Props = {
  id?: string;
  name?: string;
  value: string;
  onChanged: (name: string | undefined, value: string) => void;
  className?: string;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
  required?: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  name,
  value,
  onChanged,
  className,
  placeholder,
  maxLength,
  rows,
  required,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChanged(name, event.target.value);
  };

  return (
    <textarea
      id={id}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      maxLength={maxLength}
      rows={rows}
      required={required}
    />
  );
};
